import "../styles/globals.sass";
import AppWrapper from "../components/AppWrapper";
import Head from "next/head";
import { useEffect } from "react";
import React from "react";
import { AppTheme } from "../helper/enums"
import { AppContext } from '../provider/AppContextProvider';
import Link from 'next/link'
import { ErrorBoundary } from "../lib/bugsnag";
import { getV2HomePath } from "../helper/url";

const ErrorView = () => (
  <div className={`no-content`}>
    <p className="no-content__text">Ein Fehler ist aufgetreten.</p>
    <Link href={getV2HomePath()} className="btn btn-primary">
        Zur Startseite
    </Link>
  </div>
);


function MyApp({ Component, pageProps }) {
  const { appVersion } = React.useContext(AppContext);

  useEffect(() => {
    switch (process.env.NEXT_PUBLIC_APP_THEME) {
      case AppTheme.nb:
        document.documentElement.className = "theme-nb";
        break;
      case AppTheme.nn:
        document.documentElement.className = "theme-nn";
        break;
    }
  }, []);
  return (
    <AppWrapper>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover" />

        <meta name="robots" content="noindex" />
      </Head>
      <ErrorBoundary FallbackComponent={ErrorView}>
        <Component {...pageProps} />
      </ErrorBoundary>
    </AppWrapper>
  );
}

export default MyApp;
